import PropTypes from 'prop-types'


const notificationTypes = [ 'error', 'info', 'success', 'warning' ]


export const NotificationType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(notificationTypes).isRequired
})